<template>
  <ResidencyLandingPage v-if="isResidencyLandingV2" :slug="slug" />
  <ResidencyHub v-else :slug="slug" />
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import ResidencyHub from '@/modules/guestUi/pages/ResidencyHub.vue'
import ResidencyLandingPage from '@/modules/guestUi/pages/ResidencyLandingPage.vue'
import { useSettingStore } from '@/stores/setting'

import { FeatureFlag } from '@generated/types'

defineProps<{ slug: string }>()

const settingStore = useSettingStore()

// Decided server-side from the SSR-hydrated venue payload so first paint is already
// the correct page (no skeleton/flash). /rd/ keeps rendering ResidencyLandingPage directly.
const isResidencyLandingV2 = computed(() =>
  settingStore.flagEnabled(FeatureFlag.RESIDENCY_LANDING_V2),
)
</script>
